import React, { useEffect, useState } from 'react';
import TestCaseFilterForm from './TestCaseFilterForm';
import Modal from '../../../elements/Modal';
import { Button } from '@mui/material';

const TestCaseFilterModal = ({
  showModal,
  handleClose,
  statuses,
  priorities,
  modules,
  labels,
  projectUsers,
  loading,
  filters,
  setFilters,
  setPage,
  testSuites,
  technologyLayers,
  isReviewWorkflow
}) => {
  const defaultFilters = {
    priority: filters.priority || 'All',
    labels: filters.labels || [],
    status: filters.status || 'All',
    module: filters.module || [],
    owner: filters.owner || [],
    reviewer: filters?.reviewer || [],
    approvedBy: filters?.approvedBy || [],
    technologyLayer: filters.technologyLayer || 'All',
    geographies: filters?.geographies || [],
    languages: filters?.languages || [],
    cloudDevice: filters?.cloudDevice || [],
    platforms: filters?.platforms || [],
    subPlatforms: filters?.subPlatforms || [],
    isAutomated: filters?.isAutomated || 'All',
    browsers: filters?.browsers || [],
    testSuites: filters?.testSuites || [],
    isAutomationNeeded: filters?.isAutomationNeeded || 'All',
  };
  
  const [formData, setFormData] = useState(defaultFilters);
  const handleFormSubmit = async () => {
    try {
      const filters = { ...formData };
      setFilters(filters);
      setPage(1);
      handleClose();
      // addNotification('success', 'Filters applied successfully.');
    } catch (error) {
      const errorMessage =
        error?.message || 'Unable to apply filters to test cases.';
      console.log(errorMessage);
      // addNotification('danger', errorMessage);
    }
  };

  const handleCloseModal = () => {
    handleClose();
  };

  useEffect(() => {
    setFormData(defaultFilters);
  }, [showModal]);

  return (
    <Modal
      open={showModal}
      handleClose={handleCloseModal}
      modalTitle="Filter Test Cases"
      action={() => (
        <>
          <Button variant="outlined" onClick={handleCloseModal}>
            Cancel
          </Button>
          <Button
            variant="contained"
            title="Click to  apply filter"
            onClick={handleFormSubmit}>
            Apply
          </Button>
        </>
      )}>
      <TestCaseFilterForm
        projectUsers={projectUsers}
        statuses={statuses}
        priorities={priorities}
        modules={modules}
        labels={labels}
        loading={loading}
        formData={formData}
        setFormData={setFormData}
        testSuites={testSuites}
        technologyLayers={technologyLayers} 
        isReviewWorkflow={isReviewWorkflow}
      />
    </Modal>
  );
};

export default TestCaseFilterModal;
